import { Select } from '@mantine/core';

interface PageSizeSelectorProps {
	pageSize: number;
	setPageSize: (pageSize: number) => void;
}

export function PageSizeSelector({
	pageSize,
	setPageSize,
}: PageSizeSelectorProps) {
	return (
		<Select
			value={pageSize.toString()}
			onChange={(value) => setPageSize(Number.parseInt(value!))}
			data={['10', '20', '50', '100']}
		/>
	);
}
